var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportEntireRuleSet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 14C18.3431 14 17 15.3431 17 17V43C17 44.6569 18.3431 46 20 46H38C39.6569 46 41 44.6569 41 43V37.5C41 36.9477 40.5523 36.5 40 36.5C39.4477 36.5 39 36.9477 39 37.5V43C39 43.5523 38.5523 44 38 44H20C19.4477 44 19 43.5523 19 43V20H39V24C39 24.5523 39.4477 25 40 25C40.5523 25 41 24.5523 41 24V17C41 15.3431 39.6569 14 38 14H20ZM39 18H19V17C19 16.4477 19.4477 16 20 16H38C38.5523 16 39 16.4477 39 17V18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0384 21.7254C44.1792 21.2328 44.6694 20.9263 45.1739 21.0154C45.6784 21.1045 46.0339 21.5604 45.9974 22.0714C45.8869 23.6183 45.6818 25.1591 45.4292 26.6221C44.3234 33.0259 38.4351 37.0001 32.1339 37.0001H32V39.0001C32 39.3967 31.7656 39.7558 31.4026 39.9155C31.0396 40.0752 30.6166 40.0052 30.3242 39.7373L24.3242 34.2373C24.1176 34.0479 24 33.7804 24 33.5001C24 33.2198 24.1176 32.9524 24.3242 32.763L30.3242 27.263C30.6166 26.995 31.0396 26.9251 31.4026 27.0848C31.7656 27.2445 32 27.6036 32 28.0001V30.0001H33.3475C38.2587 30.0001 42.4644 27.1477 43.8061 22.5317C43.882 22.2707 43.9594 22.002 44.0384 21.7254ZM32.1339 35.0001C37.0734 35.0001 41.4969 32.2403 43.0339 27.9069C40.6322 30.5268 37.1283 32.0001 33.3475 32.0001H30V30.2734L26.4799 33.5001L30 36.7269V35.0001H32.1339Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportEntireRuleSet);
export default __webpack_public_path__ + "static/media/import-entire-rule-set.32045460.svg";
export { ForwardRef as ReactComponent };